module.exports = companyCodes;